import {Encoder} from "@kamp-n/ng-common-tools";

export type UserInfo = {
	id: string;
	name: string;
};

export function decodedUserInfo(encodedUserInfo: string): UserInfo | null {
	if (!encodedUserInfo) {
		return null;
	}

	try {
		const decodedUserInfo = Encoder.b64decode(encodedUserInfo);
		return JSON.parse(decodedUserInfo) as UserInfo;
	} catch (error) {
		return null;
	}
}
